/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { initDetailsAnimation } from './animate-details';

// Youtube/Vimeo popups
Fancybox.bind('.popup-youtube, .popup-vimeo', {
	on: {
		done: (fancybox) => {
			const containerSection = fancybox.options.triggerEl.closest('section');
			if (containerSection) {
				const transcription = containerSection.querySelector('[data-video-transcription]');
				if (transcription) {
					const boxContent = fancybox.container.querySelector('.fancybox__content');

					if (!boxContent.querySelector('[data-video-transcription]')) {
						const transcriptionClone = transcription.cloneNode(true);
						transcriptionClone.classList.remove('hidden');
						transcriptionClone.classList.add('absolute', 'w-full', 'top-full', 'left-0');
						boxContent.classList.add('relative');
						boxContent.append(transcriptionClone);
					}

					initDetailsAnimation(fancybox.container);
				}
			}

			fancybox.container.querySelector('.is-close-btn').focus();
			fancybox.container.querySelector('iframe').setAttribute('title', 'Play Video');
		},
	},
});

// Default WP Gallery popups
Fancybox.bind('.popup-gallery', {
	Thumbs: {
		type: 'classic',
	},
	on: {
		done: (fancybox) => {
			fancybox.container.querySelector('[data-fancybox-close]').focus();
		},
	},
});
